// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/layout/Section.jsx

import React from "react";
import StatusChip from "../data-display/StatusChip";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function Section({
  title,
  description,
  eyebrow,
  badge,
  badgeTone = "neutral",
  actions = null,
  children,
  density = "default",
  divided = true,
  className = "",
}) {
  return (
    <section
      className={joinClassNames(
        "oasys-section",
        `oasys-section--${density}`,
        divided && "oasys-section--divided",
        className
      )}
    >
      {(title || description || eyebrow || badge || actions) ? (
        <header className="oasys-section__header">
          <div className="oasys-section__heading">
            {eyebrow ? (
              <span className="oasys-section__eyebrow">{eyebrow}</span>
            ) : null}

            {title ? <h2 className="oasys-section__title">{title}</h2> : null}

            {description ? (
              <p className="oasys-section__description">{description}</p>
            ) : null}
          </div>

          {badge || actions ? (
            <div className="oasys-section__header-actions">
              {badge ? (
                <StatusChip tone={badgeTone}>{badge}</StatusChip>
              ) : null}
              {actions}
            </div>
          ) : null}
        </header>
      ) : null}

      <div className="oasys-section__body">{children}</div>
    </section>
  );
}
